module.exports = __webpack_public_path__ + "img/intelbras-solar.e884c3e0.svg";